import { throwError } from 'rxjs';
import type { ModuleDetailsContentQueryError } from './ModuleDetailsContent.model';

export function getModuleDetailsQueryError(error: ModuleDetailsContentQueryError) {
  return throwError(() => new Error(error));
}
